var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1181_70589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "url(#paint0_linear_1181_70589)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1181_70589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 11.8335C8.18759 11.8335 8.34592 11.7696 8.4737 11.6418C8.60148 11.5141 8.66536 11.3557 8.66536 11.1668V8.50016C8.66536 8.31127 8.60148 8.15294 8.4737 8.02516C8.34592 7.89738 8.18759 7.8335 7.9987 7.8335C7.80981 7.8335 7.65148 7.89738 7.5237 8.02516C7.39592 8.15294 7.33203 8.31127 7.33203 8.50016V11.1668C7.33203 11.3557 7.39592 11.5141 7.5237 11.6418C7.65148 11.7696 7.80981 11.8335 7.9987 11.8335ZM7.9987 6.50016C8.18759 6.50016 8.34592 6.43627 8.4737 6.3085C8.60148 6.18072 8.66536 6.02238 8.66536 5.8335C8.66536 5.64461 8.60148 5.48627 8.4737 5.3585C8.34592 5.23072 8.18759 5.16683 7.9987 5.16683C7.80981 5.16683 7.65148 5.23072 7.5237 5.3585C7.39592 5.48627 7.33203 5.64461 7.33203 5.8335C7.33203 6.02238 7.39592 6.18072 7.5237 6.3085C7.65148 6.43627 7.80981 6.50016 7.9987 6.50016ZM7.9987 15.1668C7.07648 15.1668 6.20981 14.9918 5.3987 14.6418C4.58759 14.2918 3.88203 13.8168 3.28203 13.2168C2.68203 12.6168 2.20703 11.9113 1.85703 11.1002C1.50703 10.2891 1.33203 9.42238 1.33203 8.50016C1.33203 7.57794 1.50703 6.71127 1.85703 5.90016C2.20703 5.08905 2.68203 4.3835 3.28203 3.7835C3.88203 3.1835 4.58759 2.7085 5.3987 2.3585C6.20981 2.0085 7.07648 1.8335 7.9987 1.8335C8.92092 1.8335 9.78759 2.0085 10.5987 2.3585C11.4098 2.7085 12.1154 3.1835 12.7154 3.7835C13.3154 4.3835 13.7904 5.08905 14.1404 5.90016C14.4904 6.71127 14.6654 7.57794 14.6654 8.50016C14.6654 9.42238 14.4904 10.2891 14.1404 11.1002C13.7904 11.9113 13.3154 12.6168 12.7154 13.2168C12.1154 13.8168 11.4098 14.2918 10.5987 14.6418C9.78759 14.9918 8.92092 15.1668 7.9987 15.1668ZM7.9987 13.8335C9.48759 13.8335 10.7487 13.3168 11.782 12.2835C12.8154 11.2502 13.332 9.98905 13.332 8.50016C13.332 7.01127 12.8154 5.75016 11.782 4.71683C10.7487 3.6835 9.48759 3.16683 7.9987 3.16683C6.50981 3.16683 5.2487 3.6835 4.21536 4.71683C3.18203 5.75016 2.66536 7.01127 2.66536 8.50016C2.66536 9.98905 3.18203 11.2502 4.21536 12.2835C5.2487 13.3168 6.50981 13.8335 7.9987 13.8335Z",
    fill: "#89490A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_70589",
    x1: 0,
    y1: 16.5,
    x2: 16,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D5AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.b9813449e0d202121d8cd711c519a8cf.svg";
export { ForwardRef as ReactComponent };